import React from "react";
import NavigationTabBar from "../components/navigation/NavigationTabBar";
import FooterSection from "../components/navigation/FooterSection";

export default function AIMockInterviewIndia() {
  return (
    <>
      {/* ✅ HEADER */}
      <NavigationTabBar />

      <div className="bg-white text-gray-900 pt-16">

        {/* HERO */}
        <section className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold leading-tight">
              AI Mock Interview Platform for Freshers in India
            </h1>

            <p className="mt-6 text-lg text-gray-600">
              Practice real HR and technical interviews using AI. Get instant
              feedback, improve your confidence, and crack your dream job.
            </p>

            <div className="mt-8 flex gap-4">
              <a
                href="/mock-interview"
                className="bg-blue-600 text-white px-6 py-3 rounded-lg font-medium"
              >
                Start Free Mock Interview
              </a>

              <a
                href="/resume-analyzer"
                className="border px-6 py-3 rounded-lg"
              >
                Analyze Resume
              </a>
            </div>

            <div className="mt-6 text-sm text-gray-500">
              ⭐ 5/5 Rating • 4,000+ Students • 94% Success Rate
            </div>
          </div>

          <img
            src="/assets/images/interview-hero.jpg"
            alt="AI mock interview practice for freshers in India"
            className="rounded-xl shadow"
            loading="lazy"
          />
        </section>

        {/* SEO CONTENT */}
        <section className="max-w-4xl mx-auto px-6 py-10">
          <h2 className="text-2xl font-bold mb-4">
            Best AI Mock Interview Platform in India
          </h2>

          <p className="text-gray-600 mb-4">
            Botervue is an AI-powered mock interview platform designed for freshers in India who want to prepare for real job interviews.
            With increasing competition in placements and hiring, students need practical interview experience.
          </p>

          <p className="text-gray-600 mb-4">
            Unlike traditional preparation methods, AI mock interviews provide instant feedback on your answers, communication, and confidence.
            This allows candidates to continuously improve and become job-ready faster.
          </p>

          <p className="text-gray-600">
            You can{" "}
            <a href="/mock-interview" className="text-blue-600 underline">
              start a mock interview
            </a>{" "}
            or{" "}
            <a href="/resume-analyzer" className="text-blue-600 underline">
              analyze your resume
            </a>{" "}
            to improve your chances of getting hired.
          </p>
        </section>

        {/* HOW IT WORKS */}
        <section className="bg-gray-50 py-16 px-6">
          <div className="max-w-5xl mx-auto text-center">
            <h2 className="text-3xl font-bold">
              How AI Mock Interview Works
            </h2>

            <div className="grid md:grid-cols-3 gap-8 mt-10">
              <div>
                <h3 className="font-semibold text-lg">Upload Resume</h3>
                <p className="text-gray-600 mt-2">
                  Add your resume and job role to get personalized questions.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-lg">AI Asks Questions</h3>
                <p className="text-gray-600 mt-2">
                  Practice real interview questions asked by companies.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-lg">Get Feedback</h3>
                <p className="text-gray-600 mt-2">
                  Receive instant feedback and improve your answers.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FEATURES */}
        <section className="py-16 px-6 max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center">
            Why Choose Botervue AI Mock Interview?
          </h2>

          <div className="grid md:grid-cols-2 gap-10 mt-10">
            <div>
              <h3 className="font-semibold text-xl">Real Interview Simulation</h3>
              <p className="text-gray-600 mt-2">
                Experience real HR and technical interview scenarios using AI.
              </p>
            </div>

            <div>
              <h3 className="font-semibold text-xl">Instant Feedback</h3>
              <p className="text-gray-600 mt-2">
                Get feedback on communication, clarity, and answers instantly.
              </p>
            </div>

            <div>
              <h3 className="font-semibold text-xl">Resume Analysis</h3>
              <p className="text-gray-600 mt-2">
                Improve your resume with ATS scoring and suggestions.
              </p>
            </div>

            <div>
              <h3 className="font-semibold text-xl">
                Built for Freshers in India
              </h3>
              <p className="text-gray-600 mt-2">
                Tailored specifically for Indian job seekers.
              </p>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="bg-gray-50 py-16 px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-center">
              Frequently Asked Questions
            </h2>

            <div className="mt-8 space-y-6">
              <div>
                <h3 className="font-semibold">
                  Is AI mock interview free in India?
                </h3>
                <p className="text-gray-600">
                  Yes, Botervue offers free AI mock interview practice.
                </p>
              </div>

              <div>
                <h3 className="font-semibold">
                  How to prepare for interviews as a fresher?
                </h3>
                <p className="text-gray-600">
                  Practice regularly and use AI mock interviews.
                </p>
              </div>

              <div>
                <h3 className="font-semibold">
                  Which is the best mock interview platform in India?
                </h3>
                <p className="text-gray-600">
                  Botervue is one of the best AI interview platforms.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 text-center">
          <h2 className="text-3xl font-bold">
            Start Your AI Mock Interview Today 🚀
          </h2>

          <a
            href="/mock-interview"
            className="mt-6 inline-block bg-blue-600 text-white px-8 py-3 rounded-lg"
          >
            Try Free Now
          </a>
        </section>
      </div>

      {/* ✅ FOOTER */}
      <FooterSection />
    </>
  );
}